import { dateFormate } from '../../../utils/helper';
import { getMessageTimestampMs } from './normalizeMessageTimestamp';

/**
 * Checks if a message is an inbound message sent by the user/contact.
 */
function isInboundUserMessage(message) {
  if (!message || typeof message !== 'object') return false;

  const origin = `${message.origin || ''}`.toUpperCase();
  if (origin === 'INBOUND') return true;
  if (origin === 'OUTBOUND') return false;

  const direction = `${message.direction || ''}`.toLowerCase();
  if (direction === 'inbound') return true;
  if (direction === 'outbound') return false;

  if (message.isMine === true) return false;
  if (message.chat_type === 'human_agent' || message.chat_type === 'bot') return false;

  return false;
}

/**
 * Resolves timestamp of the user's latest inbound message from a list of messages.
 */
function getLatestInboundMessageTimestamp(messages) {
  if (!Array.isArray(messages) || messages.length === 0) return null;

  for (let i = messages.length - 1; i >= 0; i--) {
    const msg = messages[i];
    if (isInboundUserMessage(msg)) {
      const ts = getMessageTimestampMs(msg) || msg.created_at || msg.timestamp || msg.createdAt;
      if (ts) return ts;
    }
  }

  return null;
}

/**
 * Best-effort timestamp for "Last Seen" in chat header (reflects user's last message date & time).
 */
export function getLastSeenTimestamp(user, messages = []) {
  const latestInboundTs = getLatestInboundMessageTimestamp(messages);
  if (latestInboundTs) return latestInboundTs;

  if (!user || typeof user !== 'object') return null;

  if (isInboundUserMessage(user.last_message)) {
    const ts =
      getMessageTimestampMs(user.last_message) ||
      user.last_message.created_at ||
      user.last_message.timestamp ||
      user.last_message.updated_at;
    if (ts) return ts;
  }

  const userLastInbound = user.last_inbound_message || user.last_user_message;
  if (userLastInbound) {
    const ts =
      getMessageTimestampMs(userLastInbound) ||
      userLastInbound.created_at ||
      userLastInbound.timestamp;
    if (ts) return ts;
  }

  if (user.last_active_date) return user.last_active_date;
  if (user.last_active) return user.last_active;

  if (user.last_message && user.last_message.origin !== 'OUTBOUND') {
    const ts =
      getMessageTimestampMs(user.last_message) ||
      user.last_message.created_at ||
      user.last_message.timestamp;
    if (ts) return ts;
  }

  return null;
}

export function formatLastSeenLabel(user, messages = []) {
  const timestamp = getLastSeenTimestamp(user, messages);
  if (!timestamp) return '';

  const formatted = dateFormate(timestamp, 'DD/MM/YYYY hh:mm A');
  if (!formatted) return '';

  return `Last Seen ${formatted}`;
}

export function formatPhoneSuffix(phone) {
  const value = `${phone || ''}`.trim();
  return value ? `(${value})` : '';
}
